import axiosInstance from "../axiosInstance";
import { apiEndpoints } from "../apiConfig";

const seoDataApi = {
  getSeoData: () => axiosInstance.get(apiEndpoints.getSeoData),
  getPartnerLead: () => axiosInstance.get(apiEndpoints.getpartnerLead)
};

export default seoDataApi;